/**
 * True if the hostname is `withjoy.com` itself or a subdomain (e.g. `dev.withjoy.com`).
 * Rejects lookalike hosts such as `evil-withjoy.com` or `withjoy.net`.
 */
export const isJoyHost = (hostname: string): boolean => hostname === 'withjoy.com' || hostname.endsWith('.withjoy.com');

/**
 * True if the given URL is a `withjoy.com` URL (or subdomain).
 * Returns false for unparseable input or lookalike hosts.
 *
 * Used as the "only wrap joy URLs" gate at send-time in outbound messaging providers,
 * and as a pre-check in stationery URL heuristics.
 */
export const isJoyWebsiteUrl = (url: string): boolean => {
  try {
    return isJoyHost(new URL(url).hostname);
  } catch {
    return false;
  }
};
